import { useContext, memo, useEffect } from "react";
import { BefPageContainer, BefPageControllerContext, } from "@beflam/bef-core";
import React from "react";
import { BefDialog } from "./befDialog";

export function dialogInner(props: { dialog: any }) {
    const dialog = props.dialog;
    return (
        <BefDialog dialog={dialog} visible={true} />
    );
}

const MemoDialog = memo(dialogInner, (prevProps, nextProps) => prevProps.dialog === nextProps.dialog);

export function BefDialogContainer() {
    let pageController = useContext(BefPageControllerContext);
    let [dialogs, setDialogs] = React.useState<BefPageContainer[]>(pageController.dialogPageContainers)

    useEffect(() => {
        const dialogPageContainersChangedSub = pageController.dialogPageContainersChanged.subscribe((result: any) => {
            setDialogs([].concat(result));
        });
        return () => {
            dialogPageContainersChangedSub.unsubscribe();
        };
    }, []);
    return (<>
        {
            dialogs.map((dialog: any) => {
                return (
                    <MemoDialog dialog={dialog}></MemoDialog>
                )

            })
        }
    </>);
}
